module.exports = __webpack_public_path__ + "static/media/Almarai-Light.484f9684.ttf";